import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ResourcesState } from './types';

export const getters: GetterTree<ResourcesState, RootState> = {
  //
};
